import axios from 'axios';
import qs from 'qs';
import get from 'lodash/get';
import Vue from 'vue';
import { SET_AUTH_STATE } from '../store/mutation-types';

export function setupAjax(store, router) {
  if (process.env.NODE_ENV !== 'production') {
    axios.defaults.baseURL = 'http://localhost:3000';
  } else {
    axios.defaults.baseURL = `${window.location.origin + window.location.pathname}ui`;
  }

  axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' });

  axios.interceptors.request.use(function (config) {
    config.headers.common['UI-REQUEST-ID'] =
      `f${(+new Date()).toString(16)}` +
      `f${(~~(Math.random() * 1e8)).toString(16)}`;
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (!error.response && error.message && error.message === 'Network Error') {
      const errorTime = new Date().getTime();
      Vue.prototype.$notify.error({
        title: 'Network Error',
        message: `${errorTime} Network problems or server is temporarily unavailable.`,
        duration: 25000
      });
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      store.commit(SET_AUTH_STATE, false);
      router.push('/login');
    } else if (!error.response ||
      error.response.status === 403 ||
      error.response.status === 404 ||
      error.response.status === 409 ||
      error.response.status === 422 ||
      error.response.status === 423) {
      return Promise.reject(error);
    } else {
      // const method = get(error, 'response.config.method', '');
      // const url = get(error, 'response.config.url', '');
      const message = get(error, 'response.data.reason', error.toString());
      const text = get(error, 'response.data.text', '');
      const requestId = get(error, 'response.config.headers.UI-REQUEST-ID', '');
      const errorTime = new Date().getTime();

      // console.log('request error:', error.response);
      Vue.prototype.$notify.error({
        // title: `${method.toUpperCase()} ${url}`,
        title: message,
        message: `${errorTime}-${requestId} ${text}`,
        duration: 25000
      });
    }
    return Promise.reject(error);
  });
}
